<template>
    <div id="edicaoItensLoteLicitacao">
        <b-row class="m-5 border rounded">
            <h6 class="text-left ml-3">Itens do Lote</h6>
            <b-table :fields="fieldsItens" :items="itensLote" :busy="tableBusyItens" :current-page="currentPageItens"
                hover no-border-collapse striped small sort-by="" stacked="sm" responsive show-empty>
                <template #empty>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                    <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                    </div>
                </template>
                <template #cell(DeItemMatServ)="data">
                    <b-form-input v-if="data.item.modoEdicao" :disabled="data.item.loading"
                        v-model="data.item.novaDeItemMatServ"></b-form-input>
                    <span v-else>{{ data.item.DeItemMatServ }}</span>
                </template>
                <template #cell(QtItemMatServ)="data">
                    <b-form-input v-if="data.item.modoEdicao" :disabled="data.item.loading"
                        v-model="data.item.novaQtde"></b-form-input>
                    <span v-else>{{ data.item.QtItemMatServ }}</span>
                </template>
                <template #cell(DeUnidadeMedida)="data">
                    <b-form-input v-if="data.item.modoEdicao" :disabled="data.item.loading"
                        v-model="data.item.novaUn"></b-form-input>
                    <span v-else>{{ data.item.DeUnidadeMedida }}</span>
                </template>
                <template #cell(VlUnitarioEstimado)="data">
                    <b-form-input v-if="data.item.modoEdicao" :disabled="data.item.loading"
                        v-model="data.item.novoValorUnit"></b-form-input>
                    <span v-else>{{ data.item.VlUnitarioEstimado }}</span>
                </template>
                <template #custom-foot>
                    <b-tr class="font-weight-bold">
                        <b-td colspan="5"></b-td>
                        <b-td class="text-right">
                            {{ loteVlTotalEstimado ? formatMoeda(loteVlTotalEstimado) : '' }}
                        </b-td>
                    </b-tr>
                </template>
            </b-table>
            <table-pagination v-if="totalRowsItens > pageSize" :total-rows="totalRowsItens" :per-page="pageSize"
                :firstCurrentPg="currentPageItens" @pageChange="pageChange" />
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ldiService from '@/services/licitacoes/ldiService'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import { TableField } from '@/types/table-field'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import { fieldsItemLicitacao } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { ItemLicitacao } from '@/types/licitacoes/ldi/item-licitacao'

const CompProps = Vue.extend({
    name: 'DetalhesItensDoLote',
    components: { TablePagination },
    props: {
        idLote: {
            type: Number,
            required: true
        }
    }
})

@Component
export default class DetalhesItensDoLote extends mixins(UtilsTS, CompProps) {
    fieldsItens: TableField[] = [...fieldsItemLicitacao]
    itensLote: ItemLicitacao[] = []

    pageSize = 5

    currentPageItens = 1
    totalRowsItens = 0
    tableBusyItens = false
    loteVlTotalEstimado: number | null = null

    get existeEdicaoItem(): boolean {
        return this.itensLote.some(lo => lo.modoEdicao)
    }

    async mounted(): Promise<void> {
        this.loadData()
    }

    async loadData(): Promise<void> {
        try {
            this.tableBusyItens = true
            const response = await ldiService.buscarItensLote(this.idLote, this.currentPageItens, this.pageSize)
            if (response) {
                this.itensLote = response.itensLote.map(l => {
                    const item = Object.assign(new ItemLicitacao(), l)
                    return item
                })
                this.totalRowsItens = response.totalRows
                this.loteVlTotalEstimado = response.loteVlTotalEstimado
            } else {
                this.$toast.error('Erro ao consultar os itens do lote desta licitação.');
            }
        } finally {
            this.tableBusyItens = false;
        }
    }
    async pageChange(value: number): Promise<void> {
        this.currentPageItens = value;
        await this.loadData();
    }

}
</script>